<template>
  <div>
    <div :id="id" :style="{ height: height, width: width }"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
let color = []
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      let config = this.option.config
      // if (config.labelNormal === undefined) {
      //   config.labelNormal = true
      // }
      const isAndroid = this.$store.state.app.isAndroid
      color = config.theme
        ? config.theme
        : [
          '#007EFF',
          '#1EE4DC',
          '#FFD71C',
          '#83CF46',
          '#8C3AFF',
          '#FF72DF',
          '#3ED5FF',
          '#FF7B54',
          '#79FF96',
          '#822E26',
          '#FFFFFF'
        ]
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      const OPTIONS = this.option
      let seriesData = OPTIONS.data
      this.chart.setOption({
        color: color,
        title: {
          text: this.name,
          x: 'left',
          left: '20',
          textStyle: {
            fontSize: 10,
            color: '#fff',
            lineHeight: 40,
            ...OPTIONS.config.titleTextStyle
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)',
          ...OPTIONS.config.tooltip
        },
        legend: {
          show: true,
          orient: 'vertical',
          icon: 'circle',
          itemWidth: !isAndroid ? 10 : 5,
          itemHeight: !isAndroid ? 10 : 5,
          itemGap: !isAndroid ? 12 : 8,
          data: OPTIONS.config.legendData || OPTIONS.data.map(item => {
            return item.name
          }),
          textStyle: {
            fontSize: !isAndroid ? 10 : 8,
            color: '#F1F1F3'
          },
          ...OPTIONS.config.legend
        },
        series: [
          {
            type: 'pie',
            label: {
              normal: {
                formatter: '{c}%',
                position: 'inside',
                fontSize: !isAndroid ? 12 : 8,
                color: '#ffffff',
                ...OPTIONS.config.seriesLabel
              }
            },
            labelLine: {
              ...config.labelLine
            },
            radius: config.picRadius || ['30%', '50%'],
            center: config.picCenter || ['50%', '50%'],
            roseType: config.roseType || '',
            data: seriesData
          }
        ]
      })
    }
  }
}
</script>
